// AiQ Phoenix Tech - Brand Constants and Configuration

// Use relative API path for production, BACKEND_URL for development
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

// Brand Identity
export const BRAND = {
  parent: "AiQ Phoenix Tech",
  tagline: "Where bold ideas ignite powerful, dependable tech.",
  poweredBy: "Powered by AiQuireS and JBTechnologies",
  productSuite: "AiQ Phoenix Tech — Careers",
  productName: "Resume Optimizer"
};

// Logo URLs
export const LOGO_URL = "/aiq_phoenix_tech_logo.png";
export const SCRIBE_FLOW_LOGO = "/scribe_flow_logo.png";
export const AIQUIRES_LOGO = "/aiquires-logo.png";

// Package names mapping
export const packageNames = { 
  basic: "Essential", 
  complete: "Complete", 
  career_profiler: "Career Profiler" 
};

// Color schemes for resume styling - updated with Phoenix brand colors
export const colorSchemes = [
  { id: "classic_black", name: "Classic Black", primary: "#000000", description: "Traditional" },
  { id: "phoenix_navy", name: "Phoenix Navy", primary: "#071734", description: "Professional" },
  { id: "phoenix_blue", name: "Phoenix Blue", primary: "#00a3e0", description: "Modern" },
  { id: "phoenix_orange", name: "Phoenix Orange", primary: "#E86A33", description: "Bold" },
  { id: "teal", name: "Teal", primary: "#008080", description: "Fresh" },
  { id: "executive_charcoal", name: "Charcoal", primary: "#3D3D3D", description: "Sophisticated" }
];

// Layout styles for resume formatting
export const layoutStyles = [
  { id: "single_column", name: "Single Column", description: "ATS-friendly" },
  { id: "compact", name: "Compact", description: "Fits more content" },
  { id: "executive", name: "Executive", description: "Bold header" }
];
